import Stores from "./Stores";

let stores;
const init = data => {
  stores = new Stores(data).getStores();
  stores.LoginStore.setStores(stores.WishListStore, stores.MybagStore);
  return stores;
};
const getStores = () => stores;
export { init, getStores };



// WEBPACK FOOTER //
// ./src/stores/index.js